import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServicesPage.css';
import Breadcrumbs from '../components/Breadcrumbs';
import Recording1 from '../assets/Services/Recording_3.png';
import Recording2 from '../assets/Services/Recording_2.png';

const RecordingPage = () => (
  <div className="service-page service-page--studio-child">
    <Breadcrumbs />
    <h1>Recording &amp; Mastering</h1>
    <br />

    {/* Row 1 */}
    <div className="studio-child-row">
      <div className="studio-child-text">
        <p>
          <img
            className="float-image-left"
            src={Recording1}
            alt="Recording studio setup with vocalist"
          />
          Bring your music to life with professional-grade recording, mixing, and mastering services. Whether you're a solo artist or a full band, we provide top-tier recording sessions in a fully equipped studio environment. For artists who prefer recording in a familiar setting, we also offer Mobile Recording, allowing you to capture your sound in the comfort of your own space. Once recorded, our skilled engineers will fine-tune your tracks through expert mixing and mastering, ensuring your music has the perfect balance, clarity, and impact. Whether you’re creating a demo, an EP, or a full-length album, we tailor our production approach to match your artistic vision.
        </p>
      </div>
    </div>

    <br />

    {/* Row 2 */}
    <div className="studio-child-two-col">
      <div className="studio-child-two-col-text">
        <h2 className="studio-child-heading">Services Included</h2>
        <ul>
          <li>Vocal and instrument tracking</li>
          <li>Multi-track and live recording</li>
          <li>Studio session musicians available</li>
          <li>Balance and EQ adjustments</li>
          <li>Compression and effects processing</li>
          <li>Final mastering for distribution</li>
        </ul>
      </div>

      <div className="studio-child-two-col-image">
        <img
          src={Recording2}
          alt="Audio engineer adjusting mixing board"
          className="service-image"
        />
      </div>
    </div>

    <br />

    <div className="service-cta">
      <Link to="/contact" className="cta-button">
        Request Recording Services
      </Link>
    </div>
  </div>
);

export default RecordingPage;
